<template>
  <Transition name="fade">
    <div
      v-if="showing"
      class="fixed pt-24 pb-10 inset-0 w-full h-screen flex items-center justify-center bg-semi-75 z-20"
    >
      <div class="mx-2 w-full max-w-2xl max-h-full bg-white shadow-lg rounded-lg p-8 overflow-auto">
        <div
          v-if="this.modalAction === 'add'"
          class="w-full text-left px-3 pb-3 text-teal-700 text-2xl font-bold"
        >Nuevo evento</div>
        <div
          v-if="this.modalAction === 'edit'"
          class="w-full text-left px-3 pb-3 text-teal-700 text-2xl font-bold"
        >Actualización de evento</div>
        <div class="w-full text-right sticky top-0 right-0">
          <button aria-label="close" class="text-xl text-gray-500" @click.prevent="close">×</button>
        </div>
        <div class="flex flex-col items-center">
          <form class="w-full max-w-lg" id="eventForm" @submit.prevent>
            <div class="flex flex-wrap items-center justify-around -mx-3 mb-6">
              <div class="w-1/3 px-3 mb-6 md:mb-0 flex flex-col justify-center">
                <label
                  class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                  for="image"
                >Imagen principal</label>
                <div class="relative h-40 w-40 bg-gray-200">
                  <img :src="imageURL" class="h-full w-full object-cover" alt />
                  <div
                    class="absolute cursor-pointer right-0 bottom-0 flex items-center justify-center p-2 rounded-full border-4 border-gray-500 bg-gray-700 text-gray-100 hover:bg-gray-900"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-6 w-6 fill-current"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M19 7v2.99s-1.99.01-2 0V7h-3s.01-1.99 0-2h3V2h2v3h3v2h-3zm-3 4V8h-3V5H5c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-8h-3zM5 19l3-4 2 3 3-4 4 5H5z"
                      />
                      <path d="M0 0h24v24H0z" fill="none" />
                    </svg>
                    <input
                      @change="changeImage"
                      class="cursor-pointer bottom-0 right-0 w-10 h-10 absolute block opacity-0"
                      type="file"
                      ref="image"
                      name="image"
                      accept="image/png, image/jpeg"
                    />
                  </div>
                </div>
              </div>
              <div class="w-1/3 px-3 mb-6 md:mb-0 flex flex-col justify-center">
                <label
                  class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                  for="image2"
                >Imagen secundaria</label>
                <div class="relative h-40 w-40 bg-gray-200">
                  <img :src="imageURL2" class="h-full w-full object-cover" alt />
                  <div
                    class="absolute cursor-pointer right-0 bottom-0 flex items-center justify-center p-2 rounded-full border-4 border-gray-500 bg-gray-700 text-gray-100 hover:bg-gray-900"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-6 w-6 fill-current"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M19 7v2.99s-1.99.01-2 0V7h-3s.01-1.99 0-2h3V2h2v3h3v2h-3zm-3 4V8h-3V5H5c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-8h-3zM5 19l3-4 2 3 3-4 4 5H5z"
                      />
                      <path d="M0 0h24v24H0z" fill="none" />
                    </svg>
                    <input
                      @change="changeImage2"
                      class="cursor-pointer bottom-0 right-0 w-10 h-10 absolute block opacity-0"
                      type="file"
                      ref="image2"
                      name="image2"
                      accept="image/png, image/jpeg"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="flex flex-wrap -mx-3 mb-6">
              <div class="w-full px-3 mb-6 md:mb-0">
                <label
                  class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                  for="name"
                >Título del evento</label>
                <input
                  class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                  id="name"
                  type="text"
                  name="nombre"
                  v-model="event.nombre"
                />
                <p
                  v-if="errors.name"
                  class="text-red-500 text-xs italic"
                >Escriba un titulo para el evento.</p>
              </div>
            </div>
            <div class="flex flex-wrap -mx-3 mb-6">
              <div class="w-full px-3 mb-6 md:mb-0">
                <label
                  class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                  for="description"
                >Descripción</label>
                <textarea
                  class="appearance-none block w-full h-32 bg-gray-200 text-gray-700 border rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white resize-none"
                  id="description"
                  type="text"
                  name="descripcion"
                  v-model="event.descripcion"
                />
              </div>
            </div>

            <div class="flex flex-wrap -mx-3 mb-6">
              <div class="w-full px-3 mb-6 md:mb-0">
                <label
                  class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                  for="activity"
                >Categoría</label>
                <div class="relative mb-3">
                  <select
                    class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                    name="category_id"
                    id="category"
                    v-model="event.category_id"
                  >
                    <option disabled selected>Seleccione uno</option>
                    <template v-for="category in categories">
                      <option :key="category.id" :value="category.id">{{category.name}}</option>
                    </template>
                  </select>
                  <div
                    class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
                  >
                    <svg
                      class="fill-current h-4 w-4"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                    >
                      <path
                        d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                      />
                    </svg>
                  </div>
                </div>
                <p
                  v-if="errors.category_id"
                  class="text-red-500 text-xs italic"
                >Seleccione una categoría.</p>
              </div>
            </div>

            <div class="flex flex-wrap -mx-3 mb-6">
              <div class="w-full px-3 mb-6 md:mb-0">
                <label
                  class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                  for="activity"
                >Lugar</label>
                <div class="relative mb-3">
                  <select
                    class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                    name="lugar_id"
                    id="place"
                    v-model="event.lugar_id"
                  >
                    <option disabled selected>Seleccione uno</option>
                    <template v-for="place in places">
                      <option :key="place.id" :value="place.id">{{place.nombre}}</option>
                    </template>
                  </select>
                  <div
                    class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
                  >
                    <svg
                      class="fill-current h-4 w-4"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                    >
                      <path
                        d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                      />
                    </svg>
                  </div>
                </div>
                <p v-if="errors.place_id" class="text-red-500 text-xs italic">Seleccione un lugar.</p>
              </div>
            </div>
            <div class="flex flex-wrap -mx-3 mb-6">
              <div class="w-1/2 px-3 mb-6 md:mb-0">
                <label
                  class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                  for="date"
                >Fecha de inicio</label>
                <input
                  class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                  id="date"
                  type="date"
                  name="fecha"
                  v-model="event.fecha"
                />
                <p v-if="errors.date" class="text-red-500 text-xs italic">Escriba una fecha.</p>
              </div>
              <div class="w-1/2 px-3 mb-6 md:mb-0">
                <label
                  class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                  for="date"
                >Fecha de fin</label>
                <input
                  class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                  id="endingDate"
                  type="date"
                  name="fecha_final"
                  v-model="event.fecha_final"
                />
                <p v-if="errors.date" class="text-red-500 text-xs italic">Escriba una fecha.</p>
              </div>
              <div class="w-1/2 px-3 mb-6 md:mb-0">
                <label
                  class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                  for="time"
                >Hora de inicio</label>
                <input
                  class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                  id="time"
                  type="time"
                  name="hora"
                  v-model="event.hora"
                />
                <p v-if="errors.hour" class="text-red-500 text-xs italic">Escriba una hora.</p>
              </div>
              <div class="w-1/2 px-3 mb-6 md:mb-0">
                <label
                  class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                  for="time"
                >Hora de fin</label>
                <input
                  class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                  id="endingTime"
                  type="time"
                  name="hora_final"
                  v-model="event.hora_final"
                />
                <p v-if="errors.hour" class="text-red-500 text-xs italic">Escriba una hora.</p>
              </div>
            </div>

            <div class="flex flex-wrap -mx-3 mb-6">
              <div class="w-full px-3 mb-6 md:mb-0">
                <label
                  class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                  for="activity"
                >Cuestionario</label>
                <div class="relative mb-3">
                  <select
                    class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                    name="poll_id"
                    id="poll"
                    v-model="event.poll_id"
                  >
                    <option disabled selected>Seleccione uno</option>
                    <template v-for="poll in polls">
                      <option :key="poll.id" :value="poll.id">{{poll.nombre}}</option>
                    </template>
                  </select>
                  <div
                    class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
                  >
                    <svg
                      class="fill-current h-4 w-4"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                    >
                      <path
                        d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            </div>

            <div class="flex flex-wrap -mx-3 mb-6">
              <div class="w-full px-3 mb-6 md:mb-0">
                <label
                  class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                  for="url"
                >Enlace externo</label>
                <input type="url" class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white" id="url"
                  name="url"
                  v-model="event.url">
                  <small>La URL debe contener 'http://' o 'https://'</small>
              </div>
            </div>

            <div class="flex flex-wrap -mx-3 mb-6">
              <div class="w-full px-3 mb-6 md:mb-0">
                <label
                  class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                  for="activity"
                >Subir un archivo kml o kmz</label>
                <input type="file" ref="fileInput" name="kml_file" @change="loadTextFromFile" accept=".kml, .kmz">
              </div>
            </div>

            <div class="w-full px-3 mb-6">
              <label
                class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                for="route"
              >Ruta</label>
              <div class="h-64 w-full">
                <l-map
                  ref="map"
                  class="h-full w-full z-0"
                  :zoom="zoom"
                  :minZoom="11"
                  :center="center"
                  :maxBounds="maxBounds"
                  :options="{zoomControl: false}"
                  @ready="onMapReady"
                >
                  <l-geo-json :geojson="geojsonRouter"  :options="optionsKml"/>
                  <l-geo-json :geojson="polygon" :options-style="geoStyle" />
                </l-map>
              </div>
            </div>
            <div class="flex w-full justify-end">
              <button
                class="bg-cdmx-blue-light hover:bg-cdmx-blue-dark px-4 py-2 text-center rounded-lg text-white tracking-wide"
                @click="saveEvent()"
              >Guardar</button>
              <button
                class="ml-2 bg-red-500 hover:bg-cdmx-red px-4 py-2 text-center rounded-lg text-white tracking-wide"
                @click="close()"
              >Cerrar</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script>
import { backend_url } from "../config/url.config.ts";
import polygon from "../assets/polygonChapp.json";

import { LMap, LGeoJson } from "vue2-leaflet";
import LDraw from "leaflet-draw";
import * as esri from "esri-leaflet";
import "leaflet-kml/L.KML";
import "leaflet-kmz/dist/leaflet-kmz";
import tj from "@mapbox/togeojson";

import drawLocales from "leaflet-draw-locales";

drawLocales("es");

export default {
  name: "event-modal",
  data() {
    return {
      kmzParser: null,
      drawControl: null,
      drawControlEditOnly: null,
      config: {
        headers: {
          "x-access-token": localStorage.getItem("accessToken"),
          "Content-Type": "multipart/form-data"
        }
      },
      configBinnacle: {
        headers: {
          "x-access-token": localStorage.getItem("accessToken"),
        }
      },
      places: [],
      polls: [],
      imageURL: "",
      categories: [],
      image: null,
      imageURL2: "",
      image2: null,
      url: "",
      errors: {
        name: false,
        date: false,
        hour: false,
        category_id: false,
        place_id: false,
        codeError: "Ha ocurrido un error"
      },
      maxBounds: [
        [19.395295944890695, -99.22922388422747],
        [19.43212847837641, -99.17403475153704]
      ],
      polygon: polygon,
      zoom: 13,
      center: [19.412257, -99.200871],
      showMarker: false,
      geoStyle: {
        color: "#cb2833",
        fill: false
      },
      eventRoute: null,
      geojsonRouter: null,
      new_kml: null,
      map: null,
      layerKml: null,
      layerKmz: null
    };
  },
  props: {
    showing: {
      required: true,
      type: Boolean
    },
    event: {
      required: true
    },
    aux_event: {
      required: true
    },
    modalAction: {
      required: true
    }
  },
  components: {
    LMap,
    LGeoJson
  },
  watch: {
    showing(value) {
      if (value) {
        if (this.modalAction === "edit") {
          let parsedDate = new Date(this.event.fecha);
          let parsedEndingDate = new Date(this.event.fecha_final);
          let formattedDate =
            parsedDate.getFullYear() +
            "-" +
            ("0" + (parsedDate.getMonth() + 1)).slice(-2) +
            "-" +
            ("0" + parsedDate.getDate()).slice(-2);
          let formattedEndingDate =
            parsedEndingDate.getFullYear() +
            "-" +
            ("0" + (parsedEndingDate.getMonth() + 1)).slice(-2) +
            "-" +
            ("0" + parsedEndingDate.getDate()).slice(-2);
          this.event.fecha = formattedDate;
          this.event.fecha_final = formattedEndingDate;
          this.imageURL = this.event.imagen;
          this.imageURL2 = this.event.imagen2;
        }
        return document.querySelector("body").classList.add("overflow-hidden");
      }

      document.querySelector("body").classList.remove("overflow-hidden");
    }
  },
  created(){
    let that = this;
/*     this.$socket.$subscribe("updateCategoryConfigToMonitor", () => {
      that.fetchCategories();
    }); */
  },
  mounted() {
    this.fetchPlaces();
    this.fetchCategories();
    this.fetchPolls();
  },
  methods: {
    loadTextFromFile(ev) {
      this.resetFileGeometryInMap();

      const file = ev.target.files[0];
      const fileType = file ? file.type : "";
      const reader = new FileReader();

      reader.onload = e => {
        const nameType = file.name.split(".").slice(-1)[0]

        switch(nameType){
          //case "application/vnd.google-earth.kmz":
          case 'kmz':
            let url = URL.createObjectURL(file);
            this.loadkmz(url);
            break;
          //case "application/vnd.google-earth.kml+xml":
          case 'kml':
            this.loadKml(e.target.result)
            break;
          default:
            break;
        }
      };
      if(file){
        reader.readAsText(file);
      }
    },
    loadkmz(url){
		  this.kmzParser.load(url);
    },
    loadKml(text){
      if(this.map != null){
        this.resetFileGeometryInMap();

        if(this.eventRoute !== null){
          this.map.removeLayer(this.eventRoute);
          this.eventRoute = null;
          this.map.removeControl(this.drawControlEditOnly);
          this.drawControl.addTo(this.map);
        }

        const parser = new DOMParser();
        this.new_kml = parser.parseFromString(text, 'text/xml');
        let converted = tj.kml(this.new_kml,  { styles: true });

        this.layerKml = new L.KML(this.new_kml);
        this.map.addLayer(this.layerKml);
        //this.geojsonRouter = this.layerKml.toGeoJSON();
        //this.geojsonRouter = converted
        //this.geojsonRouter = null;
      }
    },
    onMapReady: function() {
      this.$nextTick(() => {
        let that = this;
        const map = this.$refs.map.mapObject;
        this.map = this.$refs.map.mapObject;

        this.kmzParser = new L.KMZParser({
          onKMZLoaded: function(layer, name) {
            that.resetFileGeometryInMap();

            if(that.eventRoute !== null){
              map.removeLayer(that.eventRoute);
              that.eventRoute = null;
              map.removeControl(that.drawControlEditOnly);
              that.drawControl.addTo(map);
            }

            that.layerKmz = layer;
            layer.addTo(map);
          }
        });

        esri.basemapLayer("Topographic").addTo(map);
        const editableLayers = new window.L.FeatureGroup().addTo(map);
        this.drawControl = new window.L.Control.Draw({
          position: "topright",
          draw: {
            polyline: {
              allowIntersection: false
            },
            polygon: false,
            rectangle: false,
            circle: false,
            marker: false,
            circlemarker: false
          }
        });

        this.drawControlEditOnly = new window.L.Control.Draw({
          position: "topright",
          draw: {
            polyline: false,
            polygon: false,
            rectangle: false,
            circle: false,
            marker: false,
            circlemarker: false
          },
          edit: {
            featureGroup: editableLayers
          }
        });

        if (this.modalAction === "edit" && this.event.ruta !== null) {
          if(this.event.ruta.type!="FeatureCollection"){
            const routeLayer = window.L.GeoJSON.geometryToLayer(this.event.ruta);
            this.eventRoute = routeLayer;
            routeLayer.addTo(editableLayers);
            map.addControl(this.drawControlEditOnly);
          }else{

            if(this.event.kml!=null){
              let type = this.event.kml.split(".")[1]
              if(type=="kml"){
                this.layerKml = this.event.ruta;
                this.geojsonRouter = null;

                var oReq = new XMLHttpRequest();
                oReq.addEventListener("load", ()=>{
                  this.loadKml(oReq.responseText)
                });
                oReq.open("GET", backend_url+"/"+this.event.kml);
                oReq.send();
              }
              if(type=="kmz"){
                this.kmzParser.load(backend_url+"/"+this.event.kml);
              }
            }
            map.addControl(this.drawControl);
          }

        } else {
          map.addControl(this.drawControl);
        }

        map.on("draw:drawstart", e => {
          this.$refs.fileInput.value = null;
          this.resetFileGeometryInMap();
        });

        map.on("draw:created", e => {
          let layer = e.layer;
          this.eventRoute = layer;
          layer.addTo(editableLayers);
          map.removeControl(this.drawControl);
          this.drawControlEditOnly.addTo(map);
        });

        map.on("draw:edited", e => {
          let layers = e.layers;
          layers.eachLayer(layer => {
            this.eventRoute = layer;
          });
        });

        map.on("draw:deleted", e => {
          this.eventRoute = null;
          map.removeControl(this.drawControlEditOnly);
          this.drawControl.addTo(map);
        });
      });
    },
    resetFileGeometryInMap(){
      if(this.layerKml != null){
        this.map.removeLayer(this.layerKml);
        this.geojsonRouter = null;
        this.layerKml = null;
      }

      if(this.layerKmz != null){
        this.map.removeLayer(this.layerKmz);
        this.layerKmz = null;
      }
    },
    reset: function() {
      this.errors = {
        name: false,
        date: false,
        hour: false,
        category_id: false,
        place_id: false,
        codeError: "Ha ocurrido un error"
      };
      this.imageURL = "";
      this.imageURL2 = "";
      this.url = "";
      this.geojsonRouter = null;
      this.layerKml = null;
      this.layerKmz = null;
    },
    close() {
      this.reset();
      this.$emit("close", "dismiss");
    },
    //Cambiar el this.event a formData
    saveEvent() {
      const form = document.getElementById("eventForm");
      const formData = new FormData(form);
      const validForm = this.checkFormEvent(formData);

      if(this.event.url) {
        if( this.event.url.startsWith('http://') || this.event.url.startsWith('https://')) {
          if (validForm) {
            const event_image = formData.get("image");
            const event_kml = formData.get("kml_file");
            const mimeType = this.checkMimeType(event_image);
            const newDate = Date.now();

            const event_image2 = formData.get("image2");
            const mimeType2 = this.checkMimeType(event_image2);

            if (event_image && event_image.name != "") {
              let name = this.event.nombre.replace(/\s+/g,"_")
              formData.set(
                "image",
                event_image,
                name + "_" + newDate + mimeType
              );
            }

            if(event_image2 && event_image2.name !== ""){
              let name = this.event.nombre.replace(/\s+/g,"_")
              formData.set(
                "image2",
                event_image2,
                name + "_" + newDate + mimeType2
              );
            }

            if (event_kml && event_kml.name != "") {
              const mimeTypeGeometry = this.checkMimeTypeGeometry(event_kml)
              let name = this.event.nombre.replace(/\s+/g,"_")
              formData.set(
                "kml_file",
                event_kml,
                //name + "_" + newDate + ".kml"
                name + "_" + newDate + mimeTypeGeometry
              );
            }
            
            formData.append("autor_id", this.event.autor_id);

            if (this.eventRoute !== null) {
              formData.append("route", JSON.stringify(this.eventRoute.toGeoJSON()));
              formData.append("type", "draw");
            }

            if (this.layerKml !== null){
              formData.append("route", JSON.stringify(this.layerKml.toGeoJSON()));
              formData.append("type", "file");
              //formData.append("route", JSON.stringify(tj.kml(this.new_kml,  { styles: true })));
            }

            if (this.layerKmz !== null){
              formData.append("route", JSON.stringify(this.layerKmz.toGeoJSON()));
              formData.append("type", "file");
            }


            if (this.modalAction === "add") {
              this.axios
                .post(backend_url + "/api/events", formData, this.config)
                .then(response => {
                  const eventName = this.event.nombre
                  this.reset();
                  let events = response.data.events;
                  this.$emit("close", "close", events);
                  return this.axios.post(backend_url+"/api/binnacles/monitor/save/",{
                      "module": "Eventos", 
                      "action": "Creación de un evento", 
                      "observation": eventName,
                      "email": localStorage.getItem("email")
                    },
                    this.configBinnacle
                  )
                })
                .then(response => {
                  //this.$emit("close", "close", events);
                })
                .catch(error => {
                  console.error(error.response);
                  if (
                    error.response.status == 400 ||
                    error.response.status == 401
                  ) {
                    if (
                      error.response.data.name === "TokenExpiredError" ||
                      error.response.data.name === "InvalidTokenError" ||
                      error.response.data.name === "JsonWebTokenError"
                    ) {
                      this.$router.push({ path: "/login" });
                    }
                  }
                  this.showingError = true;
                });
            } else {
              if (this.modalAction === "edit") {
                this.axios
                  .put(
                    backend_url + "/api/events/" + this.event.id,
                    formData,
                    this.config
                  )
                  .then(response => {
                    let observation = ""
                    if(this.event.nombre != this.aux_event.nombre){
                      observation = `${this.aux_event.nombre} / ${this.event.nombre}`
                    } else {
                      observation = `${this.event.nombre}`
                    }

                    this.reset();
                    let events = response.data.events;
                    this.$emit("close", "close", events);
                    return this.axios.post(backend_url+"/api/binnacles/monitor/save/",{
                        "module": "Eventos", 
                        "action": "Edición de un evento", 
                        "observation": observation,
                        "email": localStorage.getItem("email")
                      },
                      this.configBinnacle
                    )
                  })
                  .then(response => {
                    //this.$emit("close", "close", events);
                  })
                  .catch(error => {
                    console.error(error.response);
                    if (
                      error.response.status == 400 ||
                      error.response.status == 401
                    ) {
                      if (
                        error.response.data.name === "TokenExpiredError" ||
                        error.response.data.name === "InvalidTokenError" ||
                        error.response.data.name === "JsonWebTokenError"
                      ) {
                        this.$router.push({ path: "/login" });
                      }
                    }
                    this.showingError = true;
                  });
              }
            }
          }
        } else {
          alert("La URL debe comenzar con 'http://' o 'https://'");
        }
      } else {
        if (validForm) {
          const event_image = formData.get("image");
          const event_kml = formData.get("kml_file");
          const mimeType = this.checkMimeType(event_image);
          const newDate = Date.now();

          const event_image2 = formData.get("image2");
          const mimeType2 = this.checkMimeType(event_image2);

          if (event_image && event_image.name != "") {
            let name = this.event.nombre.replace(/\s+/g,"_")
            formData.set(
              "image",
              event_image,
              name + "_" + newDate + mimeType
            );
          }

          if(event_image2 && event_image2.name !== ""){
            let name = this.event.nombre.replace(/\s+/g,"_")
            formData.set(
              "image2",
              event_image2,
              name + "_" + newDate + mimeType2
            );
          }

          if (event_kml && event_kml.name != "") {
            const mimeTypeGeometry = this.checkMimeTypeGeometry(event_kml)
            let name = this.event.nombre.replace(/\s+/g,"_")
            formData.set(
              "kml_file",
              event_kml,
              //name + "_" + newDate + ".kml"
              name + "_" + newDate + mimeTypeGeometry
            );
          }
          
          formData.append("autor_id", this.event.autor_id);

          if (this.eventRoute !== null) {
            formData.append("route", JSON.stringify(this.eventRoute.toGeoJSON()));
            formData.append("type", "draw");
          }

          if (this.layerKml !== null){
            formData.append("route", JSON.stringify(this.layerKml.toGeoJSON()));
            formData.append("type", "file");
            //formData.append("route", JSON.stringify(tj.kml(this.new_kml,  { styles: true })));
          }

          if (this.layerKmz !== null){
            formData.append("route", JSON.stringify(this.layerKmz.toGeoJSON()));
            formData.append("type", "file");
          }


          if (this.modalAction === "add") {
            this.axios
              .post(backend_url + "/api/events", formData, this.config)
              .then(response => {
                const eventName = this.event.nombre
                this.reset();
                let events = response.data.events;
                this.$emit("close", "close", events);
                return this.axios.post(backend_url+"/api/binnacles/monitor/save/",{
                    "module": "Eventos", 
                    "action": "Creación de un evento", 
                    "observation": eventName,
                    "email": localStorage.getItem("email")
                  },
                  this.configBinnacle
                )
              })
              .then(response => {
                //this.$emit("close", "close", events);
              })
              .catch(error => {
                console.error(error.response);
                if (
                  error.response.status == 400 ||
                  error.response.status == 401
                ) {
                  if (
                    error.response.data.name === "TokenExpiredError" ||
                    error.response.data.name === "InvalidTokenError" ||
                    error.response.data.name === "JsonWebTokenError"
                  ) {
                    this.$router.push({ path: "/login" });
                  }
                }
                this.showingError = true;
              });
          } else {
            if (this.modalAction === "edit") {
              this.axios
                .put(
                  backend_url + "/api/events/" + this.event.id,
                  formData,
                  this.config
                )
                .then(response => {
                  let observation = ""
                  if(this.event.nombre != this.aux_event.nombre){
                    observation = `${this.aux_event.nombre} / ${this.event.nombre}`
                  } else {
                    observation = `${this.event.nombre}`
                  }

                  this.reset();
                  let events = response.data.events;
                  this.$emit("close", "close", events);
                  return this.axios.post(backend_url+"/api/binnacles/monitor/save/",{
                      "module": "Eventos", 
                      "action": "Edición de un evento", 
                      "observation": observation,
                      "email": localStorage.getItem("email")
                    },
                    this.configBinnacle
                  )
                })
                .then(response => {
                  //this.$emit("close", "close", events);
                })
                .catch(error => {
                  console.error(error.response);
                  if (
                    error.response.status == 400 ||
                    error.response.status == 401
                  ) {
                    if (
                      error.response.data.name === "TokenExpiredError" ||
                      error.response.data.name === "InvalidTokenError" ||
                      error.response.data.name === "JsonWebTokenError"
                    ) {
                      this.$router.push({ path: "/login" });
                    }
                  }
                  this.showingError = true;
                });
            }
          }
        }
      }
    },
    fetchPolls() {
      this.axios.get(backend_url + "/api/polls", this.config).then(response => {
        this.polls = response.data;
      });
    },
    fetchPlaces() {
      this.axios
        .get(backend_url + "/api/places", this.config)
        .then(response => {
          this.places = response.data;
        });
    },
    fetchCategories() {
      this.axios
        .get(backend_url + "/api/config/categories/events", this.config)
        .then(response => {
          this.categories = response.data.categories;
        });
    },
    changeImage: function(event) {
      let file = event.target.files[0];
      this.imageURL = URL.createObjectURL(file);
      this.image = this.$refs.image.files[0];
    },
    changeImage2: function(event) {
      let file = event.target.files[0];
      this.imageURL2 = URL.createObjectURL(file);
      this.image2 = this.$refs.image.files[0];
    },
    checkMimeType(file) {
      let mimeType = "";
      switch (file.type) {
        case "image/jpeg":
          mimeType = ".jpeg";
          break;
        case "image/png":
          mimeType = ".png";
          break;
        case "image/jpg":
          mimeType = ".jpg";
          break;
        default:
          mimeType = "";
          break;
      }
      return mimeType;
    },

    checkMimeTypeGeometry(file) {
      let mimeType = "";
      const nameType = file.name.split(".").slice(-1)[0]
      
      switch(nameType){
        //case "application/vnd.google-earth.kmz":
        case 'kmz':
          mimeType = ".kmz"
          break;
        //case "application/vnd.google-earth.kml+xml":
        case 'kml':
          mimeType = ".kml"
          break;
        default:
          break;
      }
      return mimeType;
    },
    checkFormEvent: function(data) {
      if (data.get("nombre") === "") {
        this.errors.name = true;
      } else {
        this.errors.name = false;
      }

      if (data.get("fecha") === "") {
        this.errors.date = true;
      } else {
        this.errors.date = false;
      }

      if (data.get("fecha_final") === "") {
        this.errors.date = true;
      } else {
        this.errors.date = false;
      }

      if (data.get("hora") === "") {
        this.errors.hour = true;
      } else {
        this.errors.hour = false;
      }

      if (data.get("hora_final") === "") {
        this.errors.hour = true;
      } else {
        this.errors.hour = false;
      }

      if (data.get("category_id") === null) {
        this.errors.category_id = true;
      } else {
        this.errors.category_id = false;
      }

      if (data.get("lugar_id") === null) {
        this.errors.place_id = true;
      } else {
        this.errors.place_id = false;
      }

      if (
        this.errors.name ||
        this.errors.category_id ||
        this.errors.place_id ||
        this.errors.date ||
        this.errors.hour
      ) {
        return false;
      }

      return true;
    }
  },
  computed: {
    optionsKml(){
      return {
        onEachFeature: this.onEachFeatureFunction
      };
    },
    onEachFeatureFunction() {
      return (feature, layer) => {
        layer.bindTooltip(
          `
            <div>
            ${feature.properties.description}
            </div>
          `
        ).openTooltip();
      };
    }
  }
};
</script>

<style scoped>
.bg-semi-75 {
  background-color: rgba(0, 0, 0, 0.75);
}
.text-teal-700 {
  color: #6e5b25;
}
</style>